// Current time indicator component for timeline
// CREATED: Visual indicator showing current time on timeline
// Updates every minute to stay accurate

import { useEffect, useState } from 'react';
import { timeToPixelOffset } from '../../../lib/timeCalculations';

interface CurrentTimeIndicatorProps {
  showLabel?: boolean;
}

/**
 * Displays a horizontal line indicating the current time on the timeline
 * Only shown when viewing today's date
 */
export function CurrentTimeIndicator({ showLabel = true }: CurrentTimeIndicatorProps) {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update current time every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every 60 seconds

    return () => clearInterval(interval);
  }, []);

  const hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  const topPosition = timeToPixelOffset(timeString);

  return (
    <div
      className="absolute left-0 right-0 pointer-events-none"
      style={{
        top: `${topPosition}px`,
        zIndex: 15
      }}
    >
      {/* Indicator circle on the left */}
      <div className="absolute -left-1 -top-1.5 w-3 h-3 bg-primary-500 rounded-full border-2 border-white shadow-lg animate-pulse" />

      {/* Time line */}
      <div className="w-full h-0.5 bg-primary-500 shadow-md" />

      {/* Optional time label */}
      {showLabel && (
        <div className="absolute left-4 -top-3 bg-primary-500 text-white text-xs font-medium px-2 py-0.5 rounded shadow-lg">
          {timeString}
        </div>
      )}
    </div>
  );
}
